import { useEffect, useState } from "react";
import { Modal } from "src/components/DialogComponent";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { addUsers } from "src/modules/users/actions";
import { selectUsers } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { fieldType } from "../../../../types/form";
import { UserAvatar } from "../../avatar/Avatar";
import TGButton from "../../TGButton";
import PeoplePicker from "../peoplePicker";
import { AddButton } from "src/components/ui-icons/buttons";
import Trash from "src/components/ui-icons/buttons/Trash";
import { FiveWhyType } from "src/api/config/systemSwitch";

type Props = {
  dataField: fieldType;
  type: string;
  errors: any;
  onChange: any;
  value: string;
  defaultValues: string;
  zIndex: number;
  isMobile?: boolean;
};

function Editors(props: Props) {
  const { dataField, type, onChange, value, errors, zIndex, isMobile = false } = props;
  const [fieldValue, setFieldValue] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const dispatch = useAppDispatch();
  const [addEditor, setAddEditor] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (value && value.split(";").length > 0) {
      let emails: any = [];
      value.split(";").map((email: string) => {
        if (email) {
          emails = [...emails, email.trim()];
        }
      });
      dispatch(addUsers(emails));
    }
  }, [value]);

  useEffect(() => {
    if (fieldValue && fieldValue.length > 0) {
      if (value.indexOf(fieldValue[0]["value"].toLowerCase().trim()) !== -1) {
        const employees = value.split(";");
        const filterEmployees = employees.filter((email: string) => email !== fieldValue[0]["value"].toLowerCase().trim());
        const strEmails = filterEmployees.join(";");
        if (strEmails) {
          onChange(`${strEmails};${fieldValue[0]["value"].toLowerCase().trim()}`);
        } else {
          onChange(`${fieldValue[0]["value"].toLowerCase().trim()}`);
        }
      } else {
        onChange(`${value};${fieldValue[0]["value"].toLowerCase().trim()}`);
      }
    }
  }, [fieldValue]);

  const removeEmployeeHandle = (email: string) => {
    const employees = value.split(";");
    const filterEmployees = employees.filter((emailFilter: string) => emailFilter !== email);
    const strEmails = filterEmployees.join(";");
    onChange(strEmails);
  }

  const saveEditorCanceled = (state: boolean) => {
    onChange(`${value}`);
    setAddEditor(false);
  };

  useEffect(() => {
    if (!addEditor) {
      setFieldValue([]);
    }
  }, [addEditor]);

  const gridClass = isMobile
    ? "grid grid-cols-1 w-full mb-2.5 relative gap-2"
    : "grid grid-cols-3 w-full mb-2.5 relative gap-2";

  const cardClass = isMobile
    ? "w-full rounded-lg border p-3 bg-white justify-between items-center border-[#DFE4EA]"
    : "w-full rounded-lg border p-5 bg-white justify-between items-center border-[#DFE4EA]";

  return (
    <div className={`${dataField.width} mb-5`}>
      <FlexRow
        onClick={() => setOpen((value && value.split(";").length > 0 && !open) || false)}
        className="flex items-center justify-between w-full mb-5"
      >
        <h3 className="text-[#637381] flex items-center font-medium">
          {dataField.title} · {(value && value.split(";").length) || 0}
        </h3>
        {value && value.split(";").length > 3 && <>{(!open && <ArrowDown />) || <ArrowUp />}</>}
      </FlexRow>
      {!open && (
        <div className="flex flex-col flex-wrap w-full mb-2.5 relative gap-2">
          {value && value.split(";").length > 3 &&
            <>
              <div className={gridClass}>
                {value.split(";").map((email: string, idx: number) => (
                  <>
                    {idx <= 2 && (
                      <>
                        {users[email] ? (
                          <FlexRow
                            className={cardClass}
                          >
                            <div className="flex items-center gap-2">
                              <UserAvatar
                                avatar={users[email]?.avatar}
                                shortName={
                                  users[email]?.displayName &&
                                  users[email].displayName.split(" ")[0][0] +
                                  users[email].displayName.split(" ")[1][0]
                                }
                                displayName={users[email]?.displayName}
                                email={email}
                              />

                              <div className="flex flex-col items-start justify-center">
                                <span className={twMerge(
                                  "text-sm text-[#111928]",
                                  idx === 0 && "font-bold"
                                )}>
                                  {users[email]?.displayName}
                                </span>

                                <span
                                  className="text-sm text-[#637381]"
                                  dangerouslySetInnerHTML={{
                                    __html: users[email]?.jobTitle,
                                  }}
                                />
                              </div>
                            </div>
                            {!dataField.disabled && value.split(";").length > 1 && idx !== 0 && (
                              <FlexCol
                                onClick={() => removeEmployeeHandle(email)}
                                className="items-center h-[24px] cursor-pointer"
                              >
                                <Trash />
                              </FlexCol>
                            )}
                          </FlexRow>
                        ) : (
                          <div className="flex items-center gap-2">
                            Получаем данные о пользователе...
                          </div>
                        )}
                      </>
                    )}
                  </>
                ))}
              </div>
            </>
          }
          {value && value.split(";").length <= 3 &&
            <>
              <div className={gridClass}>
                {value.split(";").map((email: string, idx: number) => (
                  <>
                    {users[email] ? (
                      <FlexRow
                        className={cardClass}
                      >
                        <div className="flex items-center gap-2">
                          <UserAvatar
                            avatar={users[email]?.avatar}
                            shortName={
                              users[email]?.displayName &&
                              users[email].displayName.split(" ")[0][0] +
                              users[email].displayName.split(" ")[1][0]
                            }
                            displayName={users[email]?.displayName}
                            email={email}
                          />

                          <div className="flex flex-col items-start justify-center">
                            <span className={twMerge(
                              "text-sm text-[#111928]",
                              idx === 0 && "font-bold"
                            )}>
                              {users[email]?.displayName}
                            </span>

                            <span
                              className="text-sm text-[#637381]"
                              dangerouslySetInnerHTML={{
                                __html: users[email]?.jobTitle,
                              }}
                            />
                          </div>
                        </div>
                        {!dataField.disabled && value.split(";").length > 1 && idx !== 0 && (
                          <FlexCol
                            onClick={() => removeEmployeeHandle(email)}
                            className="items-center h-[24px] cursor-pointer"
                          >
                            <Trash />
                          </FlexCol>
                        )}
                      </FlexRow>
                    ) : (
                      <div className="flex items-center gap-2">
                        Получаем данные о пользователе...
                      </div>
                    )}
                  </>
                ))}
              </div>
            </>
          }
        </div>
      )}
      {open && (
        <div className={gridClass}>
          {value &&
            value.split(";").length > 0 &&
            value.split(";").map((email: string, idx: number) => (
              <>
                {users[email] ? (
                  <FlexRow
                    className={cardClass}
                  >
                    <div className="flex items-center gap-2">
                      <UserAvatar
                        avatar={users[email]?.avatar}
                        shortName={
                          users[email]?.displayName &&
                          users[email].displayName.split(" ")[0][0] +
                          users[email].displayName.split(" ")[1][0]
                        }
                        displayName={users[email]?.displayName}
                        email={email}
                      />

                      <div className="flex flex-col items-start justify-center">
                        <span className={twMerge(
                          "text-sm text-[#111928]",
                          idx === 0 && "font-bold"
                        )}>
                          {users[email]?.displayName}
                        </span>

                        <span
                          className="text-sm text-[#637381]"
                          dangerouslySetInnerHTML={{
                            __html: users[email]?.jobTitle,
                          }}
                        />
                      </div>
                    </div>
                    {!dataField.disabled && value.split(";").length > 1 && idx !== 0 && (
                      <FlexCol
                        onClick={() => removeEmployeeHandle(email)}
                        className="items-center h-[24px] cursor-pointer"
                      >
                        <Trash />
                      </FlexCol>
                    )}
                  </FlexRow>
                ) : (
                  <div className="flex items-center gap-2">
                    Получаем данные о пользователе...
                  </div>
                )}
              </>
            ))}
        </div>
      )}
      <TGButton
        type="button"
        disabled={dataField.disabled}
        color="white"
        className="w-full"
        onClick={(e) => {
          e.stopPropagation();
          setAddEditor(true);
        }}
      >
        <FlexRow><AddButton />Добавить участника</FlexRow>
      </TGButton>
      <Modal zIndex={zIndex + 70} modalClassName="min-h-px" open={addEditor} toggleDialog={saveEditorCanceled}>
        <header className="px-10 pb-4">
          <h2>Добавить участника</h2>
        </header>
        <div className="px-10 py-5">
          <PeoplePicker
            type={type}
            errors={errors}
            dataField={{
              type: "peoplePicker",
              require: true,
              single: true,
              key: "Editors",
              current: false,
              title: "ФИО сотрудника",
              placeholder: "Введите имя сотрудника",
              width: "w-full",
            }}
            value={fieldValue}
            onChange={(value) => {
              setFieldValue(value)
            }}
          />
        </div>
        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
          <TGButton
            type="button"
            color="gray"
            onClick={(e) => {
              e.stopPropagation();
              saveEditorCanceled(false);
            }}
          >
            Отмена
          </TGButton>
          <TGButton
            type="button"
            color="bluedark"
            onClick={(e) => {
              e.stopPropagation();
              setAddEditor(false);
            }}
          >
            Выбрать
          </TGButton>
        </footer>
      </Modal>
    </div>
  );
}

export default Editors;
